import {ColorUtils} from '@/model/project/utils/colorutils'
import { FillColorProperty } from "./properties/fillcolorproperty";
import { ColorProperty } from "./properties/colorproperty";
import Konva from "konva";
import tag from "@/model/tag";
import TagsService from '@/services/tags.service';
import { TextView } from './text'
import { AnalogMeterRound } from './analogmeterround';
import historydatarequest from "@/model/requests/historydatarequest";
import { RangeValueProperty } from "./properties/rangevalueproperty";
import AuthModule from "@/store/auth.module";


export class Gauge extends AnalogMeterRound{

    public drawObject():void{
        let rangeproperty:RangeValueProperty
          const rangeprop = this.properties['rangevalue'];
          let tag:tag
            if (rangeprop!=null){	
                 rangeproperty =Object.assign(new RangeValueProperty(), rangeprop);
                if (rangeproperty!=null) 
                       tag =  rangeproperty.getTag(this.tagnames)
            }	
        if (tag==null || !tag.usehistory || rangeproperty==null || !rangeproperty.showhistory)
        {
            this.drawRange(tag,rangeproperty,null, null)
            return;
        }
        if (AuthModule.currentUser!=null){
            const enddate = Date.now();
            const begindate = enddate - rangeproperty.getDuration();//delta*minutes
           const request:historydatarequest = {token:AuthModule.currentUser.accessToken, 
              name:tag.path==null?tag.name:tag.path, begindate:begindate, enddate:enddate};
            TagsService.gethistorydata(request,(data:string)=>{
                 const historydata =JSON.parse(data);
                 let hisMin:number
                 let hisMax:number
                 
                 const dataY = []
                 if(historydata.length>1){
                 historydata.forEach((data)=>{
                   dataY.push(data['y'])
                 })
                 hisMin = Math.min(...dataY)
                 hisMax = Math.max(...dataY)
                }

                 this.drawRange(tag,rangeproperty, hisMin, hisMax);
            }, 
            (data:string)=>{
                console.log('data', data);
             })
        }
    }
    private drawRange(tag:tag,rangeproperty:RangeValueProperty, hisMin:number, hisMax:number):void{
        super.initObject();

		let fillcolor = '0xffffff00'; 
        fillcolor = this.fillcolor;
        const fillprop = this.properties==null? null : this.properties['fillcolor'];
            if (fillprop!=null){	
                const fillcolorproperty:FillColorProperty =Object.assign(new FillColorProperty(), fillprop);
                if (fillcolorproperty!=null) 
                        fillcolor = fillcolorproperty.getColor(this.tagnames, this.fillcolor)     
            }	
        const fillcolor2 = ColorUtils.convertformat(fillcolor)

        let color = this.color; 
        const colorprop = this.properties==null? null : this.properties['color'];
            if (colorprop!=null){	
                const colorproperty:ColorProperty =Object.assign(new ColorProperty(), colorprop);
                if (colorproperty!=null) 
                        color = colorproperty.getColor(this.tagnames, this.fillcolor)     
            }	
        const color2 = ColorUtils.convertformat(color)    
       
  
        const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const gradientrectSmall = ctx.createLinearGradient(0, 0, 0, this.height*2/20);
          gradientrectSmall.addColorStop(0, '#000000')
          gradientrectSmall.addColorStop(1, '#FFFFFF')

        const circle = new Konva.Circle({
            x: this.width/2,
            y: this.height/2,
            radius: this.width/2,
            fill: fillcolor2,
            });
          this.node.add(circle)

        const radius = this.width/2;
		const innerradius =radius-this.width/20;
		const innerradius2 =radius-this.width/40;
		const degreestep = 270/this.interval;
		const degreestep2 = degreestep/5;
		let valuemin=0;
		let valuemax=240;
		let decimalpos=0;

        if (rangeproperty!=null){
            valuemin = rangeproperty.minimumvalue;
            valuemax = rangeproperty.maximumvalue;
            decimalpos=rangeproperty.decimalpos;
        }
        
        if(rangeproperty!=null && rangeproperty.colorrange!=null && rangeproperty.colorrange.length!=0){
            rangeproperty.colorrange.forEach((range)=>{
                const begindegree =rangeproperty.get270value(range['from'])
                const enddegree  = rangeproperty.get270value(range['to'])
                const rangeColor = range['color']
                
                const sector = new Konva.Arc({
                    x: this.width/2,
                    y: this.height/2,
                    innerRadius: 0,
                    outerRadius: this.width/2,
                    angle: begindegree-enddegree,
                    rotation:-begindegree
                })
                sector.fillRadialGradientStartPoint({ x: 0, y: 0 });
                sector.fillRadialGradientStartRadius(0);
                sector.fillRadialGradientEndRadius(this.width/2);
                sector.fillRadialGradientColorStops([0.75, ColorUtils.convertformat(rangeColor).slice(0,-2)+'00',
                    1, ColorUtils.convertformat(rangeColor)])
                this.node.add(sector)
            })
        }
        if(rangeproperty!=null && rangeproperty.showhistory){
            const begindegree = rangeproperty.get270value(hisMin);
            const enddegree = rangeproperty.get270value(hisMax)

            const sectorHistory = new Konva.Arc({
                x: this.width/2,
                y: this.height/2,
                innerRadius: 0,
                outerRadius: this.width/3,
                angle: begindegree-enddegree,
                rotation:-begindegree
                    })
            sectorHistory.fillRadialGradientStartPoint({ x: 0, y: 0 });
            sectorHistory.fillRadialGradientStartRadius(0);
            sectorHistory.fillRadialGradientEndRadius(this.width/3);
            sectorHistory.fillRadialGradientColorStops([0.75, ColorUtils.convertformat(rangeproperty.historycolor).slice(0,-2)+'00',
                1, ColorUtils.convertformat(rangeproperty.historycolor)])
            this.node.add(sectorHistory)
        }

        const valuestep = (valuemax-valuemin)/this.interval;

        for (let i=0;i<=this.interval;i++){
            const degrees=degreestep*i-45;
            const radians = degrees*(Math.PI/180);
            const x1=this.width/2-radius*Math.cos(radians);
            const y1=this.height/2-radius*Math.sin(radians);
            const x2=this.width/2-innerradius*Math.cos(radians);
            const y2=this.height/2-innerradius*Math.sin(radians);
            const line = new Konva.Line({
                points: [x1, y1, x2, y2],
                strokeWidth: this.width/100,
                stroke: 'white'
            })
            this.node.add(line)
            for (let j=1; j<5; j++){
                if (i==this.interval) break;
                const degrees2 = degrees+degreestep2*j;
                const radians2 = degrees2*(Math.PI/180);
                const x12=this.width/2-radius*Math.cos(radians2);
                const y12=this.height/2-radius*Math.sin(radians2);
                const x22=this.width/2-innerradius2*Math.cos(radians2);
                const y22=this.height/2-innerradius2*Math.sin(radians2);
                const line2 = new Konva.Line({
                    points: [x12, y12, x22, y22],
                    strokeWidth: this.width/150,
                    stroke: 'white'
                })
                this.node.add(line2)
            }
            
            const value = valuemin+valuestep*i;
				const valuetext = value.toFixed(decimalpos).toString()
                const textTob = new TextView()
                textTob.width = this.width/4
                textTob.height = this.height/15
                textTob.text = valuetext
                textTob.fontsize = this.height/15
                textTob.textplacement =degrees>92? 2:degrees<88?0:1
                textTob.textcolor = 'white'
                textTob.useborder = false
                textTob.bordercolor = null
                textTob.linewidth = 1
                textTob.fill = false
                textTob.fillcolor = 'white'
                textTob.underline = false

                if (degrees<0){
					textTob.posx = (x2)
					textTob.posy = (y2-this.height/25)
                }else if(degrees<88){
					textTob.posx = (x2)
					textTob.posy = (y2-this.height/60)
				}else if(degrees>180){
					textTob.posx = (x2-this.width/4)
					textTob.posy = (y2-this.height/25)
                }else if(degrees>92){
                    textTob.posx = (x2-this.width/4);
					textTob.posy = (y2-this.height/60)
                }else{
                    textTob.posx = (x2-this.width/8);
					textTob.posy = (y2+this.height/60)
                }

                textTob.initLayer(this.layer)
                textTob.drawObject()
                this.node.add(textTob.rotatednode)
        }
            
        const textUnit = new TextView()
                textUnit.width = this.width/4
                textUnit.height = this.height/10
                textUnit.text = this.unit
                textUnit.fontsize = this.height/10
                textUnit.posx = this.width/2-this.width/8
                textUnit.posy = this.height*9/20-this.height/10
                textUnit.textplacement = 1
                textUnit.textcolor = 'white'
                textUnit.useborder = false
                textUnit.bordercolor = null
                textUnit.linewidth = 1
                textUnit.fill = false
                textUnit.fillcolor = 'white'
                textUnit.underline = false
                textUnit.initLayer(this.layer)
                textUnit.drawObject()
                this.node.add(textUnit.rotatednode)

     
        let arrowWidth = this.width/60
        let arrowHeight = innerradius2
        if (arrowWidth<1)  arrowWidth = 1;
        if (arrowHeight<1) arrowHeight = 1;
        
        const arrow = new Konva.Rect({
            x: 0,
            y: 0,
            width: arrowWidth,
            height: arrowHeight,
            fill: color2,
          }); 
        this.node.add(arrow)

        const tagvalue = tag==null? 0: rangeproperty.getCurrentValue270deg(Number(tag.tagvalue))
        
        const anglearr = tagvalue-135;
		const radians = anglearr*Math.PI/180;
       
        const posx = this.width/2 -arrowWidth/2;
        const posy = this.width/2 -arrowHeight/2

        const x =arrowWidth/2+posx-arrowWidth/2* Math.cos(radians) +(arrowHeight)* Math.sin(radians);
        const y = posy+arrowHeight/2 -(arrowWidth/2)* Math.sin(radians) -(arrowHeight)* Math.cos(radians);
    
        arrow.position({x:x,y:y})
        arrow.rotation(anglearr) 
        
       const circleBall = new Konva.Circle({
            x: this.width/2,
            y: this.height/2,
            radius: 2*arrowWidth,
            fill: color2
            });
          this.node.add(circleBall)
          
        if (this.usedigital){
			const digrect = new Konva.Rect({
                x: this.width/3,
                y: this.height*30/40,
                width: this.width/3,
                height: this.height*2/20,
                cornerRadius: this.height/100,
                stroke: gradientrectSmall,
                strokeWidth: this.height/100,
            })
              digrect.fillLinearGradientStartPoint({ x: 0, y: 0 });
              digrect.fillLinearGradientEndPoint({ x: 0, y: this.height*3/20 });
              digrect.fillLinearGradientColorStops([0, 'white', 0.25, 'black'])
              this.node.add(digrect)

            let tagvalueText =tag==null? 0: Number(tag.tagvalue)
            if(rangeproperty!=null && +tagvalueText>rangeproperty.maximumvalue) tagvalueText = rangeproperty.maximumvalue
            if(rangeproperty!=null && +tagvalueText<rangeproperty.minimumvalue) tagvalueText = rangeproperty.minimumvalue

               const valueTextOb = new TextView()
                valueTextOb.width = this.width/3
                valueTextOb.height = this.height/15
                valueTextOb.text = tagvalueText.toFixed(decimalpos).toString();
                valueTextOb.fontsize = this.height/15
                valueTextOb.posx = this.width/2-this.width/6
                valueTextOb.posy = this.height*33/40-this.height/18
                valueTextOb.textplacement = 1
                valueTextOb.textcolor = 'white'
                valueTextOb.useborder = false
                valueTextOb.bordercolor = null
                valueTextOb.linewidth = 0
                valueTextOb.fill = false
                valueTextOb.fillcolor = 'white'
                valueTextOb.underline = false
                valueTextOb.initLayer(this.layer)
                valueTextOb.drawObject()
                this.node.add(valueTextOb.rotatednode)
            }

       const textLabel = new TextView()
        textLabel.width = this.width/2
        textLabel.height = this.height/15
        textLabel.text = this.text
        textLabel.fontsize = this.height/15
        textLabel.posx = this.width/2-this.width/4
        textLabel.posy = this.height*14/20-this.height/19
        textLabel.textplacement = 1
        textLabel.textcolor = 'white'
        textLabel.useborder = false
        textLabel.bordercolor = null
        textLabel.linewidth = 1
        textLabel.fill = false
        textLabel.fillcolor = 'white'
        textLabel.underline = false
        textLabel.initLayer(this.layer)
        textLabel.drawObject()
        this.node.add(textLabel.rotatednode)
           
    }
}